import React from 'react';
import { FieldArrayRenderProps, FormikProps } from 'formik';
import { Button } from 'antd';
import cx from 'classnames';

import {
  AssignmentRateTypeEnum,
  SelectTeammateViewModel,
  AssignmentTeammateSelectModel,
  AssignmentTeammateTypeEnum,
} from 'api/backofficeApiClient';
import {
  isAddButtonVisible,
  isRemoveButtonVisible,
} from 'utils/fieldArrayUtils';
import InternalReportSection from './InternalReportSection';
import { AssignmentInfoFormValues } from 'components/modals/AssignmentDataModal/AssignmentInfo';

import styles from './InternalReportSectionArray.module.less';

const MAX_INTERNAL_REPORT_SECTION = 5;

type Props = FieldArrayRenderProps & {
  teammates: SelectTeammateViewModel[];
  isTeammatesLoaded: boolean;
};

// Filter already selected teammates
const getFilteredTeammates = (
  teammates: SelectTeammateViewModel[],
  setIndex: number,
  formTeammatesSets: AssignmentTeammateSelectModel[],
) => {
  const teammatesInOtherSets = formTeammatesSets.map((set, index) =>
    setIndex === index ? [] : set.userId,
  );
  return teammates.filter(
    (teammate) =>
      !teammatesInOtherSets.includes(teammate.userId || teammate.email),
  );
};

export default function InternalReportSectionArray(props: Props) {
  const { teammates, isTeammatesLoaded, form } = props;
  const { internalReports } = (form as FormikProps<AssignmentInfoFormValues>)
    .values;

  return (
    <>
      {internalReports.length > 0 &&
        internalReports.map(
          (internalReport: AssignmentTeammateSelectModel, index: number) => {
            const filteredTeammates = getFilteredTeammates(
              teammates,
              index,
              internalReports,
            );

            return (
              <div key={index} className={styles.internalReportingSection}>
                <InternalReportSection
                  index={index}
                  formik={form}
                  formNamePrefix={props.name}
                  teammates={filteredTeammates}
                  isTeammatesLoaded={isTeammatesLoaded}
                  actionButtons={
                    <>
                      {isAddButtonVisible<AssignmentTeammateSelectModel>(
                        internalReports,
                        index,
                        MAX_INTERNAL_REPORT_SECTION,
                      ) && (
                        <Button
                          className={cx('borderless-btn', styles.btn)}
                          onClick={() =>
                            props.push({
                              userId: '',
                              rate: '',
                              teammateType: AssignmentTeammateTypeEnum.Teammate,
                              externalFullName: undefined,
                              rateType: AssignmentRateTypeEnum.Percent,
                            })
                          }
                          icon={<span className="icon icon-plus-filled" />}
                        />
                      )}

                      {isRemoveButtonVisible<AssignmentTeammateSelectModel>(
                        internalReports,
                      ) && (
                        <Button
                          className={cx('borderless-btn', styles.btn)}
                          onClick={() => props.remove(index)}
                          icon={<span className="icon icon-closed-filled" />}
                        />
                      )}
                    </>
                  }
                />
              </div>
            );
          },
        )}
    </>
  );
}
